/**
 * @generated SignedSource<<f6cbca7e1d3b15e7fb7b010817cfdb9b>>
 * @relayHash 855977eee4dc8f8afaf177c6636929f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e24600dba40800addd7e7f5405bcf0a60708f9fd582ada3b27552b5bf1d59bd3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GlobalSpaceQuery$variables = {
  cloudId: string;
};
export type GlobalSpaceQuery$data = {
  readonly confluence_questionsConfiguration: {
    readonly confluenceQuestionsGlobalSpaceKey: string | null | undefined;
    readonly hasConfluenceQuestionsAccess: boolean | null | undefined;
  } | null | undefined;
};
export type GlobalSpaceQuery = {
  response: GlobalSpaceQuery$data;
  variables: GlobalSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceQuestionsConfiguration",
    "kind": "LinkedField",
    "name": "confluence_questionsConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "confluenceQuestionsGlobalSpaceKey"
      },
      {
        "kind": "ScalarField",
        "name": "hasConfluenceQuestionsAccess"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "855977eee4dc8f8afaf177c6636929f7",
    "id": "e24600dba40800addd7e7f5405bcf0a60708f9fd582ada3b27552b5bf1d59bd3",
    "metadata": {},
    "name": "GlobalSpaceQuery",
    "operationKind": "query",
    "text": "query GlobalSpaceQuery($cloudId:ID!){confluence_questionsConfiguration(cloudId:$cloudId){confluenceQuestionsGlobalSpaceKey,hasConfluenceQuestionsAccess}}"
  }
};
})();

(node as any).hash = "71240671beed53a76fe0194ab89a147b";

export default node;
